import { render, staticRenderFns } from "./Trips.vue?vue&type=template&id=3cc7b024&scoped=true&"
import script from "./Trips.vue?vue&type=script&lang=js&"
export * from "./Trips.vue?vue&type=script&lang=js&"
import style0 from "./Trips.vue?vue&type=style&index=0&id=3cc7b024&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc7b024",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3cc7b024')) {
      api.createRecord('3cc7b024', component.options)
    } else {
      api.reload('3cc7b024', component.options)
    }
    module.hot.accept("./Trips.vue?vue&type=template&id=3cc7b024&scoped=true&", function () {
      api.rerender('3cc7b024', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Trips.vue"
export default component.exports